import { ModeAppProxyAPI, } from '@moderepo/mode-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var EventLogsActionType;
(function (EventLogsActionType) {
    EventLogsActionType["SET_EVENT_LOGS_DATA"] = "set event logs data";
    EventLogsActionType["CLEAR_EVENT_LOGS_DATA"] = "clear event logs data";
})(EventLogsActionType || (EventLogsActionType = {}));
export const setEventLogsData = (homeId, logResourcePath, data, searchParams) => {
    return {
        type: EventLogsActionType.SET_EVENT_LOGS_DATA,
        homeId,
        logResourcePath,
        data,
        searchParams,
    };
};
export const clearEventLogsData = (homeId, logResourcePath) => {
    return {
        type: EventLogsActionType.CLEAR_EVENT_LOGS_DATA,
        homeId,
        logResourcePath,
    };
};
/**
 * Fetch event logs data for a specific homeId, logResourcePath, and filters
 */
export const fetchEventLogs = (homeId, logSourcePath, filters) => {
    return async (dataDispatch) => {
        const modifiedFilters = {
            ...filters,
            // change pageSize/pageNumber to skip/limit
            skip: (filters === null || filters === void 0 ? void 0 : filters.pageNumber) !== undefined && (filters === null || filters === void 0 ? void 0 : filters.pageSize) !== undefined ? filters.pageNumber * filters.pageSize : undefined,
            limit: (filters === null || filters === void 0 ? void 0 : filters.pageSize) !== undefined ? filters.pageSize : undefined,
            // exclude pageSize/pageNumber
            pageNumber: undefined,
            pageSize: undefined,
        };
        const response = await ModeAppProxyAPI.getInstance().getEventLog(homeId, logSourcePath, modifiedFilters);
        await dataDispatch(setEventLogsData(homeId, logSourcePath, response, searchParamsToString(filters)));
    };
};
